var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"grey lighten-4","large":""},on:{"click":_vm.signIn}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-google")]),_vm._v("Sign In ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }